import type { JSX } from 'react'

import { useCallback } from 'react'
import { ButtonIconSizes } from 'atoms/Button'
import { InlineCloseButton } from 'atoms/Button/Templates'
import { PopupUnderLayer } from 'atoms/PopupUnderLayer'
import { PopupColumnGap, PopupRowGap } from 'blocks/Popup'
import { PopupScrollableBlockDefault } from 'blocks/Popup/Popup.styled'
import { COLOR } from 'vars/color'
import { INDENTS } from 'vars/indents'
import {
  CloseWrapperSC,
  DescriptionWrapperSC,
  HeaderWrapperSC,
  InfoPopupOverlaySC,
  InfoPopupSC,
} from './PlayerInfoPopup.styled'

export interface IPlayerInfoPopup {
  onClose: () => void
  toggleClassName?: string
  gap?: PopupColumnGap
  backgroundColor?: COLOR
  children: React.ReactNode
}

export const PlayerInfoPopup = ({
  onClose,
  toggleClassName,
  gap = PopupColumnGap.INDENT_0,
  backgroundColor = COLOR.SURFACE_DARK_4,
  children,
}: IPlayerInfoPopup): JSX.Element => {
  const header = children?.[0]
  const body = children?.[1]

  const onCloseHandler = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation()
      e.preventDefault()
      onClose?.()
    },
    [onClose]
  )

  return (
    <InfoPopupOverlaySC>
      <PopupUnderLayer
        onClose={onClose}
        toggleClassName={toggleClassName}
        position='absolute'
        transform='translate(-50%, -50%)'
        left='50%'
        top='50%'
      >
        <InfoPopupSC gap={gap} backgroundColor={backgroundColor}>
          <CloseWrapperSC>
            <InlineCloseButton
              onClick={onCloseHandler}
              paddings={[INDENTS.INDENT_0]}
              iconSize={ButtonIconSizes.xSm}
            />
          </CloseWrapperSC>
          {!!header && <HeaderWrapperSC>{header}</HeaderWrapperSC>}
          {!!body && (
            <DescriptionWrapperSC>
              <PopupScrollableBlockDefault
                rowGapDescription={PopupRowGap.INDENT_0}
              >
                {body}
              </PopupScrollableBlockDefault>
            </DescriptionWrapperSC>
          )}
        </InfoPopupSC>
      </PopupUnderLayer>
    </InfoPopupOverlaySC>
  )
}
